import type { Json } from "@/types/supabase.types";

export function formatVariableDefault(value: Json | null | undefined): string {
  if (value === null || value === undefined) return "";
  if (Array.isArray(value)) {
    return `${value.length} ${value.length === 1 ? "value" : "values"}`;
  }
  if (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  ) {
    return String(value);
  }
  return JSON.stringify(value);
}
